import { connect } from 'react-redux';
import BaseForm from '../BaseForm/BaseForm';
import {
  addCompany,
  showError,
  clearErrors,
} from '../../redux/actions/companies';

interface Props {
  model: any;
  fields: any;
  values: any;
  id: number;
  onUpdate: Function;
  dispatch: Function;
  item: any;
  disable: boolean;
  showHeading: boolean;
  isTypeForm?: boolean;
  meta?: any;
}

class CompanyCreateForm extends BaseForm<Props> {
  static defaultProps = {
    isTypeForm: true,
  };

  constructor(props) {
    super(props, {
      onSubmit: addCompany,
      name: 'Company',
      action: 'Add',
      type: 'create',
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    // Phone numbers are location specific and I don't know if this app
    // will be used outside of the uk so just checking empty for the moment
    if (isIndex(1) && BaseForm.validator.isEmpty(String(data.phone_number))) {
      this.props.dispatch(showError('Please specify a phone number'));
      return false;
    }
    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('create.name', ''));
    dispatch(actions.change('create.phone_number', ''));
  }
}

const mapStateToProps = ({ companies }) => ({
  model: companies,
  fields: BaseForm.fields.companies.create,
  values: {},
});

export default connect(mapStateToProps)(CompanyCreateForm);
